/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builder_Plan_CtaInputs */

const en_builder_plan_cta = /** @type {(inputs: Builder_Plan_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get Builder`)
};

const id_builder_plan_cta = /** @type {(inputs: Builder_Plan_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ambil Builder`)
};

/**
* | output |
* | --- |
* | "Get Builder" |
*
* @param {Builder_Plan_CtaInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const builder_plan_cta = /** @type {((inputs?: Builder_Plan_CtaInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builder_Plan_CtaInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_builder_plan_cta(inputs)
	return en_builder_plan_cta(inputs)
});